import React, { useState, useEffect } from "react";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { Redirect } from "react-router-dom";
import { useQuery } from "../../utils/hooks/useQuery";
import { fetchOpenId } from "../../services/api/accounts";
import { showToast } from "../../utils/helper";
import { useSelector, useDispatch } from "react-redux";
import { authSuccess } from "../../actions/auth";

export const Autologin = () => {
  const [loading, setLoading] = useState(true);
  const auth = useSelector((state) => state.auth);
  const { authenticated, error, loading: loadingAuth } = auth;
  const dispatch = useDispatch();
  let query = useQuery();
  const redirectionUrl = query.get("redirectionUrl");

  useEffect(() => {
    setLoading(() => true);
    const querySession = query.get("session");
    const context = JSON.parse(atob(querySession));

    sessionStorage.setItem("authenticated", "true");
    sessionStorage.setItem("context", JSON.stringify(context));
    dispatch(authSuccess());
    dispatch({ type: "server/authenticate", payload: { token: context.accessToken } });
    setLoading(() => false);
  }, []);

  if (authenticated === true) {
    return <Redirect to={redirectionUrl} />;
  }

  return loading ? (
    <CircularProgress style={{ height: "150px", width: "150px" }} />
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>El usuario no existe en el sistema</h1>
    </div>
  );
};
